module.exports = __webpack_public_path__ + "img/s-hd.83e3a5a5.webp";